import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from 'react-ga4';
import ScrollToTop from './ScrollToTop';

import PaymentSuccess from './PaymentSuccess'
import CriticalSafe from './criticalSafe';
import Landing from './Landing';
import FAQ from './Faq';
import CLAIM from './Claims';


ReactGA.initialize([{
	trackingId: 'G-TB8S8X3J35',
	debug: true,
	gaOptions: {
		cookieDomain: 'auto'
	}
}]);

ReactGA.event({
  category: "your category",
  action: "your action",
  label: "your label", // optional
  value: 99, // optional, must be a number
  nonInteraction: true, // optional, true/false
  transport: "xhr", // optional, beacon/xhr/image
});

export default function App() {

	const [referral, setReferral] = useState('');

	useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const cParam = urlParams.get('r');
  
        if (cParam) {
	     console.log('params r= '+cParam);		
          sessionStorage.setItem('referral', cParam);
          setReferral(cParam);
        }
  
    }, []);

	useEffect(() => {
        //ReactGA.pageview(window.location.pathname + window.location.search);
		ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search,title:"Critical Safe"});
		console.log(window.location.pathname + window.location.search);
		console.log('send GA');
    });

	return (
		<Router>
			<div id="content-wrapper" className="container-fluid">
				<nav className="navbar navbar-light navbar-expand-lg bg-transparent">
					<div className="navbar-brand d-flex text-white clickable">
						<a  href={process.env.MIX_INSTAPOL_DOMAIN}><img className="instapol-logo" src="../images/instapol-new-white-logo.png" alt="Howden Insurance Brokers Sdn Bhd" loading="lazy" /></a>
					</div>
					<button className="navbar-toggler text-white border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
						<i className="fas fa-bars" />
					</button>
					<div className="collapse navbar-collapse" id="navbar">
						<ul className="navbar-nav ms-auto">
							<li className="nav-item">
								<a className="nav-link text-white fw-bold" href={process.env.MIX_INSTAPOL_DOMAIN}>Home</a>
							</li>
							<li className="nav-item dropdown">
								<a className="nav-link dropdown-toggle text-white fw-bold" id="aboutDropdown" role="button" data-bs-toggle="dropdown"  aria-haspopup="false" aria-expanded="false">
									Our Products
								</a>
								<ul className="dropdown-menu" aria-labelledby="aboutDropdown">
								
									<li><a className="dropdown-item" href="https://instapol.my/motor?s=criticalsafe">Car Insurance</a></li>
									<li><a className="dropdown-item" href="https://howden-bike.instapol.my/landing?s=criticalsafe">Bicycle Insurance</a></li>
									<li><a className="dropdown-item" href="https://howden-travelplus.instapol.my/landing?s=criticalsafe">Travel Insurance</a></li>
									<li><a className="dropdown-item" href="https://howden-house.instapol.my/landing?s=criticalsafe">HomeProtect</a></li>
								</ul>
							</li>
							<li className="nav-item dropdown">
								<a className="nav-link text-white fw-bold dropdown-toggle" id="aboutDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
									About Us
								</a>
								<ul className="dropdown-menu" aria-labelledby="aboutDropdown">
								
									<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/about-us"}>About instaPol</a></li>
									<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_PRIVACY}>Privacy Policy</a></li>
									<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/refund-policy"}>Refund Policy</a></li>
									<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_COOKIES}>Cookies Policy</a></li>
									<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_TREMS}>Terms and Conditions</a></li>
								</ul>
							</li>
							<li className="nav-item">
								<a className="btn btn-outline-primary text-white fw-bold" href="/Faq">FAQs</a>
							</li>
							<li className="nav-item">
								<a className="btn btn-outline-primary text-white fw-bold" href="/Claims">Contact Us & Claims</a>
							</li>
						</ul>
					</div>
				</nav>
				<ScrollToTop />
				<Switch>
					<Route exact path="/landing">
						<Landing referral={referral} setReferral={setReferral}/>
					</Route>

					<Route exact path="/critical-safe">
						<CriticalSafe referral={referral} setReferral={setReferral}/>
					</Route>
					
					<Route exact path="/success">
						<PaymentSuccess />
					</Route>

					<Route exact path="/Faq">
						<FAQ />
					</Route>

					<Route exact path="/Claims">
						<CLAIM />
					</Route>
				</Switch>
				<section id="footer" className="mt-4">
					<div className="row">
						<div className="col-12">
							<footer id="home-footer">
								<div className="container">
									<div className="row">
										<div className="col-6">
											<a href={process.env.MIX_INSTAPOL_DOMAIN}>
												<img src="../images/instapol-new-logo.png" id="instapol-logo" alt="Instapol" width={150} loading="lazy" />
											</a>
											<p className="d-flex justify-content-between mt-3">
												<div className="row">
													<div className="col-12 col-sm-3 border-right">
														<a className="btn btn-link" href="https://www.howdengroup.com/my-en/privacy-and-data-protection">
															Privacy Notice
														</a>
													</div>
													<div className="col-12 col-sm-3 border-right">
														<a className="btn btn-link" href={process.env.MIX_INSTAPOL_DOMAIN + "/refund-policy"}>
															Refund Policy
														</a>
													</div>
													<div className="col-12 col-sm-3 border-right">
														<a className="btn btn-link" href="https://www.howdengroup.com/my-en/terms-and-conditions">
															Terms &amp; Conditions
														</a>
													</div>
													<div className="col-12 col-sm-3">
														<a className="btn btn-link" href="https://www.howdengroup.com/my-en/complaints_handling">
															Complaints Handling and Resolution Guide
														</a>
													</div>

												</div>
											</p>
											<p>Copyright © 2021 Instapol. All rights reserved.</p>
										</div>
										<div className="col-6 text-right">
											<p>Developed and owned by</p>
											<a href={process.env.MIX_HOWDENGROUP_DOMAIN}>
												<img src="../images/Howden_Corporate_Logo_CobaltBlue_RGB.png" id="howden-logo" alt="Howden Insurance Brokers Sdn Bhd" width={200} loading="lazy" />
											</a>
											<p className="mt-3 mb-0">Howden Insurance Brokers Sdn. Bhd. (197801001023)</p>
											<p>Howden Takaful Brokers Sdn. Bhd. (198001010734)</p>
										</div>
									</div>
								</div>
							</footer>
						</div>
					</div>
				</section>
			</div>
		</Router>
	);
}
